//
// ===== File env.ts    
//
'use strict';

export const firebaseConfig = {
  apiKey: "AIzaSyCkYoBNqLxOBy_e996ckebSAl5HJ_T6ea0",
  authDomain: "booshay-d3fcd.firebaseapp.com",
  databaseURL: "https://booshay-d3fcd.firebaseio.com",
  projectId: "booshay-d3fcd",
  storageBucket: "booshay-d3fcd.appspot.com",
  messagingSenderId: "1014135877824"
};

export const appName = 'pool';
export const displayHeader = 'Booshay Pool';
export const authBaseUrl = 'http://192.168.1.104:8081/booshay-account/rest';
export const appBaseUrl = 'http://192.168.1.104:8081/booshay-soccer/rest';
export const centralMediaURL = 'http://dev-media.booshay.com/account/';



// WEBPACK FOOTER //
// ./src/app/shared/env.ts